export const OSS_URL = process.env.VUE_APP_OSS_URL

export const VIDEO_URL = OSS_URL + '/website'
export const IMG_URL = process.env.VUE_APP_OSS_IMG_URL
export const VUE_APP_PUNISH_URL = process.env.VUE_APP_PUNISH_URL
export const VUE_APP_ZBY_WEB = process.env.VUE_APP_ZBY_WEB
export const noLoadingUrlList = ['/operations/user_action/add']
export const WE_DOMAIN = ''
export const DOMAIN = ''
export const WE_MAIN_URL = ''
export const LIVE_URL = ''
export const MAIN_URL = ''
export const WE_CHANNEL = 'ENWECLASS' // open-api 渠道名称
export const WE_APP_ID = '458fe0db28b0D97208b907a291ea16a3' // open-api 分配至渠道的app id
export const APP_SECRET = '*iTo%Eu4R#y#=Pml3X4T*Of84o_^J=X2' // open-api 加密秘钥
export default {
  OSS_URL,
  VIDEO_URL,
  IMG_URL,
  VUE_APP_PUNISH_URL,
  VUE_APP_ZBY_WEB,
  noLoadingUrlList,
  WE_DOMAIN,
  DOMAIN,
  WE_MAIN_URL,
  LIVE_URL,
  MAIN_URL,
  WE_CHANNEL,
  WE_APP_ID,
  APP_SECRET
}
